import Band from './charts/Band';
import Bar from './charts/Bar';
import Line from './charts/Line';
import Table from './charts/Table';
import ReactLoading from "react-loading";
import axios from 'axios';
import { useState, useEffect } from 'react';
import dummyJson from "../data/dummy.json";

const displayChart = (json, isLoding, basename) => {
  if (isLoding || Object.keys(json).length === 0) {
    return (
      <section className="py-36 sm:py-48 text-main-blue">
        <div>
          <ReactLoading
            type="spin"
            color="#2E75B6"
            height="100px"
            width="100px"
            className="mx-auto"
          />
          <p className="text-center mt-3">読み込み中</p>
        </div>
      </section>
    );
  } else {
    switch (json.chartType) {
      case "band":
        return <Band json={json} basename={basename} />
      case "bar":
        return <Bar json={json} basename={basename} />
      case "line":
        return <Line json={json} basename={basename} />
      case "table":
        return <Table json={json} basename={basename} />
      default:
        return <div className="bg-main-blue-100 py-36 sm:py-48 text-main-blue">データを取得できませんでした。再読み込みしてください。</div>
    }
  }
};

const jsonFilePath = selectedState => {
  const {
    areaId,
    pathId,
    fieldId,
    partId,
    sectionId,
    elementId
  } = selectedState
  const rootPath = (process.env.REACT_APP_IS_EXTERNAL && process.env.REACT_APP_EXTERNAL_NETLIFY_URL) || "/"
  return `${rootPath}data/json/${partId}/${sectionId}/${elementId}/${partId}_${sectionId}_${elementId}_${areaId}_${pathId}_${fieldId}.json`
}

const basename = (selectedState) => {
  const basenames = {
    "C0": "進学者全体",
    "C1": "大学進学者全体",
    "C2": "短大進学者全体",
    "C3": "専門学校進学者全体",
  }
  return basenames[selectedState.pathId]
}

function ChartArea({ selectedState }) {
  const [chartData, setChartData] = useState({});
  const [isLodingState, setLodingState] = useState(true);
  useEffect(() => {
    setLodingState(true)
    axios.get(jsonFilePath(selectedState), { timeout: 3000 }).then((response) => {
      setChartData(response.data);
    }).catch(() => {
      setChartData(dummyJson)
    }).finally(() => {
      setLodingState(false)
    })
  }, [selectedState])
  return (
    <div className="my-3 sm:my-6 mx-0 sm:mx-2 font-semibold text-center">
      { displayChart(chartData, isLodingState, basename(selectedState)) }
    </div>
  );
}

export default ChartArea;
